export default __webpack_public_path__ + "media/images/svg/forest-green-50-caret.svg";